import { PdfPreviewScreen } from '~/components/organisms/previewBar/components/pdf/PdfPreviewScreen';
import { APP_SCREEN_NAMES } from '~/constants/common';
import useBuilderStore from '~/store/useBuilderStore';

import { AppsPreviewScreen } from '../apps/AppsPreviewScreen';
import { ImagesPreviewScreen } from '../images/ImagesPreviewScreen';
import { InitialEmptyScreen } from '../InitialEmptyScreen';
import { ListOfLinksPreviewScreen } from '../list-of-links/ListOfLinksPreviewScreen';
import { SocialMediaPreviewScreen } from '../social-media/SocialMediaPreviewScreen';
import { VCardPlusPreviewScreen } from '../vcard-plus/VCardPlusPreviewScreen';
import { WebsitePreviewScreen } from '../website/WebsitePreviewScreen';

type PreviewScreenProps = {
  templateId: string;
};
export const PreviewScreen = ({ templateId }: PreviewScreenProps) => {
  const { activeStep } = useBuilderStore();

  if (!activeStep) {
    return <InitialEmptyScreen />;
  }

  if (String(templateId) === APP_SCREEN_NAMES.WEBSITE) {
    return <WebsitePreviewScreen />;
  }

  if (templateId === APP_SCREEN_NAMES.PDF) {
    return <PdfPreviewScreen />;
  }

  if (templateId === APP_SCREEN_NAMES.LIST_OF_LINKS) {
    return <ListOfLinksPreviewScreen />;
  }

  if (templateId === APP_SCREEN_NAMES.APPS) {
    return <AppsPreviewScreen />;
  }

  if (templateId === APP_SCREEN_NAMES.IMAGES) {
    return <ImagesPreviewScreen />;
  }

  if (templateId === APP_SCREEN_NAMES.VCARD_PLUS) {
    return <VCardPlusPreviewScreen />;
  }

  if (templateId === APP_SCREEN_NAMES.SOCIAL_MEDIA) {
    return <SocialMediaPreviewScreen />;
  }

  if (templateId === APP_SCREEN_NAMES.SOCIAL_MEDIA) {
    return <SocialMediaPreviewScreen />;
  }
};
